import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { Settings, Save, Key, Monitor } from 'lucide-react';

export default function SettingsPage() {
  const [settings, setSettings] = useState({});
  const [passwords, setPasswords] = useState({ current: '', newPw: '', confirm: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await api.get('/settings');
        setSettings(data.settings || {});
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    fetch();
  }, []);

  const handleSaveSettings = async () => {
    try {
      await api.put('/settings', {
        app_password: settings.app_password,
        poll_interval: settings.poll_interval,
        default_image_duration: settings.default_image_duration,
        default_html_duration: settings.default_html_duration,
        system_name: settings.system_name,
      });
      toast.success('Settings saved');
    } catch (err) { toast.error('Failed'); }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwords.newPw !== passwords.confirm) {
      return toast.error('Passwords do not match');
    }
    try {
      await api.put('/auth/password', {
        currentPassword: passwords.current,
        newPassword: passwords.newPw,
      });
      toast.success('Password changed');
      setPasswords({ current: '', newPw: '', confirm: '' });
    } catch (err) { toast.error(err.response?.data?.error || 'Failed'); }
  };

  if (loading) return <div className="loading-page"><span className="spinner" /></div>;

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h2>Settings</h2>
          <div className="page-header-sub">System configuration</div>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 20, maxWidth: 600 }}>
        {/* System Settings */}
        <div className="card card-padded">
          <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Monitor size={18} /> System Settings
          </h3>

          <div className="form-group">
            <label className="form-label">System Name</label>
            <input className="form-input" value={settings.system_name || ''}
              onChange={e => setSettings({ ...settings, system_name: e.target.value })} />
          </div>

          <div className="form-group">
            <label className="form-label">Android App Password</label>
            <input className="form-input" value={settings.app_password || ''}
              onChange={e => setSettings({ ...settings, app_password: e.target.value })}
              placeholder="1111" />
            <span style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>
              TV app eke login karanakota mema password eka use karanawa
            </span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Poll Interval (sec)</label>
              <input className="form-input" type="number" min="10" max="300"
                value={settings.poll_interval || 30}
                onChange={e => setSettings({ ...settings, poll_interval: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Image Duration (sec)</label>
              <input className="form-input" type="number" min="1" max="300"
                value={settings.default_image_duration || 10}
                onChange={e => setSettings({ ...settings, default_image_duration: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">HTML Duration (sec)</label>
              <input className="form-input" type="number" min="1" max="300"
                value={settings.default_html_duration || 15}
                onChange={e => setSettings({ ...settings, default_html_duration: e.target.value })} />
            </div>
          </div>

          <button className="btn btn-primary" onClick={handleSaveSettings}>
            <Save size={16} /> Save Settings
          </button>
        </div>

        {/* Change Admin Password */}
        <div className="card card-padded">
          <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Key size={18} /> Change Admin Password
          </h3>
          <form onSubmit={handleChangePassword}>
            <div className="form-group">
              <label className="form-label">Current Password</label>
              <input className="form-input" type="password" value={passwords.current}
                onChange={e => setPasswords({ ...passwords, current: e.target.value })} required />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input className="form-input" type="password" value={passwords.newPw}
                onChange={e => setPasswords({ ...passwords, newPw: e.target.value })} required minLength={6} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input className="form-input" type="password" value={passwords.confirm}
                onChange={e => setPasswords({ ...passwords, confirm: e.target.value })} required />
            </div>
            <button type="submit" className="btn btn-primary">
              <Key size={16} /> Change Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
